import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-create" }
const _hoisted_2 = { class: "grid-x" }
const _hoisted_3 = { class: "cell small-12 large-3" }
const _hoisted_4 = { class: "cell small-12 large-8 x3large-7" }

import { ref, onMounted } from 'vue'
import { useSkillsStore } from "@/stores/skills.store";
import { useProjectShowStore } from "@/stores/projects/show.store";
import { useProjectEditStore } from "@/stores/projects/edit.store";
import { ProjectFormData } from "@/ts/interfaces";
import SideBanner from "@/components/utils/SideBanner.vue";

import ProjectForm from "@/components/client/projects/ProjectForm.vue";
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectEditView',
  setup(__props) {

const projectId = parseInt(router.currentRoute.value.params.id)

const skillStore = useSkillsStore()
const projectEditStore = useProjectEditStore()
const projectshowStore = useProjectShowStore()

skillStore.listSkills()

const formData = ref<ProjectFormData>({
  role_title: '',
  years_of_experience: null,
  usd_hourly_rate: null,
  job_description: '',
  job_description_link: '',
  skills: [],
  complementary_skills: [],
});

const redirectOnSave = () => {
  router.push({ name: 'client-projects-index' })
}

const submitForm = async () => {
  const response = await projectEditStore.edit(projectId, formData.value)

  if(response.ok) {
    redirectOnSave()
  }
}

onMounted(async () => {
  await projectshowStore.getProjectInfo(projectId)
  const project = projectshowStore.project

  formData.value = {
    role_title: project.role_title,
    years_of_experience: project.years_of_experience,
    usd_hourly_rate: project.usd_hourly_rate,
    job_description: project.job_description,
    job_description_link: project.job_description_link,
    skills: project.skills.map(skill => skill.id),
    complementary_skills: project.complementary_skills.map(skill => skill.id),
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SideBanner, {
          "back-route-name": "client-projects-index",
          "banner-text": "Edit Project",
          "banner-img": "image-new-project.png"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ProjectForm, {
          "form-data": formData.value,
          onSubmitAction: submitForm
        }, null, 8, ["form-data"])
      ])
    ])
  ]))
}
}

})